//@ts-ignore
import { formatFloatAsCurrencySymbol } from '../common/helpers.mjs'
import useLocalization from '../hooks/useLocalization'

interface EORServicesProps {
   HasEOR: boolean
   className: string
   currencyObject: {
      Thousand_separator: string
      Decimal_separator: string
      Code: string
      Symbol: string
   }
   bookId: number
}

const BackGroundChecks = new Map()
BackGroundChecks.set(200, 39)
BackGroundChecks.set(201, 53)
BackGroundChecks.set(205, 64)
BackGroundChecks.set(204, 60)
BackGroundChecks.set(202, 36)
BackGroundChecks.set(203, 31)
BackGroundChecks.set(300, 39)
BackGroundChecks.set(301, 53)
BackGroundChecks.set(305, 64)
BackGroundChecks.set(304, 60)
BackGroundChecks.set(302, 36)
BackGroundChecks.set(303, 31)
// const MobilityServices = new Map();
// MobilityServices.set(200, 39);
// MobilityServices.set(201, 53);
// MobilityServices.set(205, 64);
// MobilityServices.set(204, 60);
// MobilityServices.set(202, 36);
// MobilityServices.set(203, 31);
const EquityEssentials = new Map()
EquityEssentials.set(200, 39)
EquityEssentials.set(201, 53)
EquityEssentials.set(205, 64)
EquityEssentials.set(204, 60)
EquityEssentials.set(202, 36)
EquityEssentials.set(203, 31)
EquityEssentials.set(300, 39)
EquityEssentials.set(301, 53)
EquityEssentials.set(305, 64)
EquityEssentials.set(304, 60)
EquityEssentials.set(302, 36)
EquityEssentials.set(303, 31)
const CountryTransferService = new Map()
CountryTransferService.set(200, 450)
CountryTransferService.set(201, 608)
CountryTransferService.set(205, 743)
CountryTransferService.set(204, 689)
CountryTransferService.set(202, 414)
CountryTransferService.set(203, 360)
CountryTransferService.set(300, 450)
CountryTransferService.set(301, 608)
CountryTransferService.set(305, 743)
CountryTransferService.set(304, 689)
CountryTransferService.set(302, 414)
CountryTransferService.set(303, 360)
const BenefitsService = new Map()
BenefitsService.set(200, 15)
BenefitsService.set(300, 15)
// BenefitsService.set(201, 0);
// BenefitsService.set(205, 0);
// BenefitsService.set(204, 0);
// BenefitsService.set(202, 0);
// BenefitsService.set(203, 0);
const EmployeeTerminationService = new Map()
EmployeeTerminationService.set(200, 350)
EmployeeTerminationService.set(201, 473)
EmployeeTerminationService.set(205, 578)
EmployeeTerminationService.set(204, 536)
EmployeeTerminationService.set(202, 322)
EmployeeTerminationService.set(203, 280)
EmployeeTerminationService.set(300, 350)
EmployeeTerminationService.set(301, 473)
EmployeeTerminationService.set(305, 578)
EmployeeTerminationService.set(304, 536)
EmployeeTerminationService.set(302, 322)
EmployeeTerminationService.set(303, 280)
const WetInkService = new Map()
WetInkService.set(200, 80)
WetInkService.set(201, 108)
WetInkService.set(205, 132)
WetInkService.set(204, 122)
WetInkService.set(202, 74)
WetInkService.set(203, 64)
WetInkService.set(300, 80)
WetInkService.set(301, 108)
WetInkService.set(305, 132)
WetInkService.set(304, 122)
WetInkService.set(302, 74)
WetInkService.set(303, 64)
const ForeignCurrencySalaries = new Map()
ForeignCurrencySalaries.set(200, 50)
ForeignCurrencySalaries.set(201, 68)
ForeignCurrencySalaries.set(205, 83)
ForeignCurrencySalaries.set(204, 77)
ForeignCurrencySalaries.set(202, 46)
ForeignCurrencySalaries.set(203, 40)
ForeignCurrencySalaries.set(300, 50)
ForeignCurrencySalaries.set(301, 68)
ForeignCurrencySalaries.set(305, 83)
ForeignCurrencySalaries.set(304, 77)
ForeignCurrencySalaries.set(302, 46)
ForeignCurrencySalaries.set(303, 40)
const BankTransferFunding = new Map()
BankTransferFunding.set(200, 5)
BankTransferFunding.set(201, 7)
BankTransferFunding.set(205, 8)
BankTransferFunding.set(204, 8)
BankTransferFunding.set(202, 5)
BankTransferFunding.set(203, 4)
BankTransferFunding.set(300, 5)
BankTransferFunding.set(301, 7)
BankTransferFunding.set(305, 8)
BankTransferFunding.set(304, 8)
BankTransferFunding.set(302, 5)
BankTransferFunding.set(303, 4)
// const MandatoryLocalTaxes = new Map();
// MandatoryLocalTaxes.set(200, 39);
// MandatoryLocalTaxes.set(201, 53);
// MandatoryLocalTaxes.set(205, 64);
// MandatoryLocalTaxes.set(204, 60);
// MandatoryLocalTaxes.set(202, 36);
// MandatoryLocalTaxes.set(203, 31);

function getWithDefault(map: Map<number, number>, bookId: number): number {
   return map.get(bookId) ?? map.get(300) ?? 0
}

export default function EORServices({
   HasEOR,
   className,
   currencyObject,
   bookId,
}: EORServicesProps) {
   const host_url =
      process.env.REACT_APP_HOST_URL || 'https://quote.bamboohr.net'
   const { getString } = useLocalization(host_url)

   if (HasEOR) {
      return (
         <div className={className}>
            <b className='productHeader'>
               {getString(
                  'quote.AdditionalEORServices.Header',
                  'Additional Remote Europe Holder B.V (\"Remote\") Direct Fees you may be subject to (these fees are subject to change at anytime):',
               )}
            </b>
            <br />
            <table
               className='tableClass4'
               cellPadding='0'
               cellSpacing='0'
               style={{ marginTop: '1em' }}
            >
               <thead>
                  <tr>
                     <th colSpan={2} scope='colgroup'>
                        &nbsp;
                     </th>
                  </tr>
               </thead>
               <tfoot>
                  <tr>
                     <td colSpan={2}>&nbsp;</td>
                  </tr>
               </tfoot>
               <tbody>
                  <tr>
                     <td>Background checks</td>
                     <td>
                        {formatFloatAsCurrencySymbol(
                           getWithDefault(BackGroundChecks, bookId),
                           currencyObject,
                        )}{' '}
                        per check
                     </td>
                  </tr>
                  <tr>
                     <td>Mobility Services</td>
                     <td>
                        <i>Variable based on case</i>
                     </td>
                  </tr>
                  <tr>
                     <td>Equity essentials</td>
                     <td>
                        {formatFloatAsCurrencySymbol(
                           getWithDefault(EquityEssentials, bookId),
                           currencyObject,
                        )}{' '}
                        pepm
                     </td>
                  </tr>
                  <tr>
                     <td>Country transfer service</td>
                     <td>
                        {formatFloatAsCurrencySymbol(
                           getWithDefault(CountryTransferService, bookId),
                           currencyObject,
                        )}{' '}
                        Ad-hoc
                     </td>
                  </tr>
                  <tr>
                     <td>Benefits service</td>
                     <td>
                        {BenefitsService.has(bookId)
                           ? formatFloatAsCurrencySymbol(
                                BenefitsService.get(bookId),
                                currencyObject,
                             ) + ' pepm'
                           : 'Billed in local currency at time of charge'}
                     </td>
                  </tr>
                  <tr>
                     <td>Employee termination service</td>
                     <td>
                        {formatFloatAsCurrencySymbol(
                           getWithDefault(EmployeeTerminationService, bookId),
                           currencyObject,
                        )}{' '}
                        Ad-hoc
                     </td>
                  </tr>
                  <tr>
                     <td>Wet ink service</td>
                     <td>
                        {formatFloatAsCurrencySymbol(
                           getWithDefault(WetInkService, bookId),
                           currencyObject,
                        )}{' '}
                        Ad-hoc
                     </td>
                  </tr>
                  <tr>
                     <td>Foreign currency salaries</td>
                     <td>
                        {formatFloatAsCurrencySymbol(
                           getWithDefault(ForeignCurrencySalaries, bookId),
                           currencyObject,
                        )}{' '}
                        pepm
                     </td>
                  </tr>
                  <tr>
                     <td>Bank transfer funding</td>
                     <td>
                        {formatFloatAsCurrencySymbol(
                           getWithDefault(BankTransferFunding, bookId),
                           currencyObject,
                        )}{' '}
                        per transfer
                     </td>
                  </tr>
                  <tr>
                     <td>Mandatory local taxes</td>
                     <td>
                        <i>Variable based on case</i>
                     </td>
                  </tr>
               </tbody>
            </table>
         </div>
      )
   } else return <></>
}
